import { createContext } from 'react';

const solicitudesContext = createContext();

export default solicitudesContext;